import { useEffect, useRef, useState } from 'react';
import { CaretDown } from '@phosphor-icons/react';
import { cx, getTextStyles } from '@eti/styles';
import { m as motion, AnimatePresence } from 'framer-motion';
import { DangerousHtmlContent } from '@eti/components';
import { Text, textVariants, vars } from '@etg/wings';
import { TRACKING_PROPERTIES, useProductSnowplowTracking } from '../../../custom-hooks/useProductSnowplowTracking';
import { useProductCardContext } from '../../context/ProductCardContext';
import { DYNAMIC_ICON } from '../../utils/dynamic-icons/icons';
import { useDynamicIcon } from '../../utils/dynamic-icons/useDynamicIcon';
import { useLinksAccessibility } from '../../../custom-hooks/useLinkAccessibility';
import { clickableArea, contentText, fontSize, readMoreContentStyles, standardGrid, toggleIconStyles, wrapperStyles } from './styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const motionVariantsOfContent = {
  enter: {
    height: 'auto',
    transition: {
      type: 'tween',
      duration: 0.3,
      when: 'beforeChildren'
    }
  },
  exit: {
    height: 0,
    transition: {
      type: 'tween',
      duration: 0.3,
      when: 'afterChildren'
    }
  }
};
const ReadMore = _ref => {
  let {
    customGrid,
    children,
    className
  } = _ref;
  const [isOpen, setIsOpen] = useState(false);
  const [icon] = useDynamicIcon(vars.colors.links.default, DYNAMIC_ICON.linkIcon);
  const {
    readMoreButtonLabel,
    readMoreContent,
    productName,
    title
  } = useProductCardContext();
  const rootElement = useRef(null);
  const {
    sendClickEvent,
    addTrackingEventOnLinks
  } = useProductSnowplowTracking(productName);
  const handleToggle = () => {
    setIsOpen(prevIsOpen => !prevIsOpen);
  };
  useLinksAccessibility({
    targetElement: rootElement,
    productTitle: title,
    accordionOpen: isOpen
  });
  useEffect(() => {
    if (isOpen) {
      sendClickEvent({
        property: TRACKING_PROPERTIES.READ_MORE
      });
      addTrackingEventOnLinks(rootElement);
    }
  }, [isOpen, sendClickEvent, addTrackingEventOnLinks]);
  return readMoreContent ? /*#__PURE__*/_jsxs("div", {
    className: cx(className, wrapperStyles, customGrid || standardGrid),
    "data-abtest": "new-readMore-design",
    "data-testid": `${productName}-readmore-container`,
    ref: rootElement,
    children: [/*#__PURE__*/_jsxs("button", {
      "aria-controls": `${productName}-readMoreContent`,
      "aria-expanded": isOpen,
      "aria-label": `${readMoreButtonLabel} ${title}`,
      className: cx(getTextStyles(), clickableArea),
      "data-testid": `${productName}-readMoreLink`,
      onClick: handleToggle,
      type: "button",
      children: [/*#__PURE__*/_jsx(Text, {
        variant: textVariants._14_BOLD,
        children: readMoreButtonLabel
      }), /*#__PURE__*/_jsx(CaretDown, {
        className: toggleIconStyles(isOpen),
        color: "#262626",
        "data-testid": `${productName}-readMoreButtonIcon`,
        size: 24,
        weight: "light"
      })]
    }), isOpen && /*#__PURE__*/_jsx(AnimatePresence, {
      children: /*#__PURE__*/_jsxs(motion.div, {
        animate: isOpen ? 'enter' : 'exit',
        className: readMoreContentStyles,
        "data-testid": "motion-component",
        initial: false,
        variants: motionVariantsOfContent,
        children: [/*#__PURE__*/_jsx(DangerousHtmlContent, {
          className: cx(getTextStyles(), fontSize, contentText(icon), 'text'),
          content: readMoreContent !== null && readMoreContent !== void 0 ? readMoreContent : '',
          id: `${productName}-readMoreContent`
        }), children && /*#__PURE__*/_jsx("div", {
          className: "children",
          children: children
        })]
      })
    })]
  }) : null;
};
export default ReadMore;
//# sourceMappingURL=ReadMore.js.map